import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { BrowserRouter } from 'react-router-dom';
import Keycloak from 'keycloak-js'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import { Spinner } from 'reactstrap';
import App from './App';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store from './stores/store';
import persistor from './stores/persistedStore';
export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});
const keycloak = new Keycloak({
    url: 'https://admin.svom.eu/keycloak/',
    realm: 'svom-fsc',
    clientId: 'FSC_SPA_WEB',
});

const keycloakOptions = {
    onLoad: 'login-required',
    enableLogging: true     
}
/*
use the function the Loading for  <Spinner color="primary" />



  
   */
const Loading = () => (<div id='table-error'>
    <Spinner color="primary" />
</div>);
/*
use the function the onTokenChange for valid value  localStorage.setItem('authToken', tokens.token);



  
   */

const onTokenChange = (tokens) => {
    localStorage.setItem('authToken', tokens.token);
};

/* render show1
   <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </PersistGate>
  
   */

ReactDOM.render(


    <ReactKeycloakProvider authClient={keycloak} initOptions={keycloakOptions}
    LoadingComponent={<Loading />} onTokens={onTokenChange}>

<Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>

</ReactKeycloakProvider>

    ,
    document.getElementById('root'));

